/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	/*global __webpack_modules__ __webpack_require__*/
	/**
	 * Perform initialization.
	 *
	 * This module aims to do complete everything synchronously, before
	 * the experiment developer's code begins.
	 *
	 * Note: This module is designed to be run as the first thing in a chunk.
	 */
	
	var WithdrawExperimentException = __webpack_require__(2);
	var assign = __webpack_require__(3);
	var manifest = assign(__webpack_require__(4), {"cohortId":"28329143","experimentId":"EXPERIMENT-2176","cohortName":"control","product":"JIRA","browsers":{"chrome":"55","firefox":"50"},"eventPrefix":"grow0.experiment2176"});
	var bowser = __webpack_require__(5);
	if (!bowser.check(manifest.browsers || {}, true)) {
	  throw new WithdrawExperimentException();
	}
	
	var analytics = __webpack_require__(7);
	try {
	  /**
	   * Setup error reporting for unhandled rejections.
	   */
	  Promise.unhandledRejection = function (reason) {
	    var bubbleUpError = __webpack_require__(17);
	    bubbleUpError(reason);
	    analytics.error(reason);
	  };
	
	  var context = __webpack_require__(18);
	  analytics.setContext(context);
	
	  __webpack_require__(21);
	} catch (e) {
	  if (!(e instanceof WithdrawExperimentException)) {
	    analytics.error(e);
	    throw e;
	  }
	}
	/**
	 * Dedicated to Austin! <3
	 */
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	 Yaku v0.18.5
	 (c) 2015 Yad Smood. http://ysmood.org
	 License MIT
	*/
	/*
	 Yaku v0.17.9
	 (c) 2015 Yad Smood. http://ysmood.org
	 License MIT
	*/
	(function () {
	    "use strict";
	
	    var $undefined
	    , $null = null
	    , isBrowser = typeof window === "object"
	    , root = isBrowser ? window : global
	    , nativePromise = root.Promise
	    , process = root.process
	    , console = root.console
	    , isLongStackTrace = false
	    , Arr = Array
	    , Err = Error
	
	    , $rejected = 1
	    , $resolved = 2
	    , $pending = 3
	
	    , $Symbol = "Symbol"
	    , $iterator = "iterator"
	    , $species = "species"
	    , $speciesKey = $Symbol + "(" + $species + ")"
	    , $return = "return"
	
	    , $unhandled = "_uh"
	    , $promiseTrace = "_pt"
	    , $settlerTrace = "_st"
	
	    , $invalidThis = "Invalid this"
	    , $invalidArgument = "Invalid argument"
	    , $fromPrevious = "\nFrom previous "
	    , $promiseCircularChain = "Chaining cycle detected for promise"
	    , $unhandledRejectionMsg = "Uncaught (in promise)"
	    , $rejectionHandled = "rejectionHandled"
	    , $unhandledRejection = "unhandledRejection"
	
	    , $tryCatchFn
	    , $tryCatchThis
	    , $tryErr = { e: $null }
	    , $noop = function () {}
	    , $cleanStackReg = /^.+\/node_modules\/yaku\/.+\n?/mg
	    ;
	
	    /**
	     * This class follows the [Promises/A+](https://promisesaplus.com) and
	     * [ES6](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-promise-objects) spec
	     * with some extra helpers.
	     * @param  {Function} executor Function object with two arguments resolve, reject.
	     * The first argument fulfills the promise, the second argument rejects it.
	     * We can call these functions, once our operation is completed.
	     */
	    var Yaku = function (executor) {
	        var self = this,
	            err;
	
	        // "this._s" is the internao state of: pending, resolved or rejected
	        // "this._v" is the internal value
	
	        if (!isObject(self) || self._s !== $undefined)
	            throw genTypeError($invalidThis);
	
	        self._s = $pending;
	
	        if (isLongStackTrace) self[$promiseTrace] = genTraceInfo();
	
	        if (executor !== $noop) {
	            if (!isFunction(executor))
	                throw genTypeError($invalidArgument);
	
	            err = genTryCatcher(executor)(
	                genSettler(self, $resolved),
	                genSettler(self, $rejected)
	            );
	
	            if (err === $tryErr)
	                settlePromise(self, $rejected, err.e);
	        }
	    };
	
	    Yaku["default"] = Yaku;
	
	    extend(Yaku.prototype, {
	        /**
	         * Appends fulfillment and rejection handlers to the promise,
	         * and returns a new promise resolving to the return value of the called handler.
	         * @param  {Function} onFulfilled Optional. Called when the Promise is resolved.
	         * @param  {Function} onRejected  Optional. Called when the Promise is rejected.
	         * @return {Yaku} It will return a new Yaku which will resolve or reject after
	         * @example
	         * the current Promise.
	         * ```js
	         * var Promise = require('yaku');
	         * var p = Promise.resolve(10);
	         *
	         * p.then((v) => {
	         *     console.log(v);
	         * });
	         * ```
	         */
	        then: function (onFulfilled, onRejected) {
	            if (this._s === undefined) throw genTypeError();
	
	            return addHandler(
	                this,
	                newCapablePromise(Yaku.speciesConstructor(this, Yaku)),
	                onFulfilled,
	                onRejected
	            );
	        },
	
	        /**
	         * The `catch()` method returns a Promise and deals with rejected cases only.
	         * It behaves the same as calling `Promise.prototype.then(undefined, onRejected)`.
	         * @param  {Function} onRejected A Function called when the Promise is rejected.
	         * This function has one argument, the rejection reason.
	         * @return {Yaku} A Promise that deals with rejected cases only.
	         * @example
	         * ```js
	         * var Promise = require('yaku');
	         * var p = Promise.reject(new Error("ERR"));
	         *
	         * p['catch']((v) => {
	         *     console.log(v);
	         * });
	         * ```
	         */
	        "catch": function (onRejected) {
	            return this.then($undefined, onRejected);
	        },
	
	        /**
	         * Register a callback to be invoked when a promise is settled (either fulfilled or rejected).
	         * Similar with the try-catch-finally, it's often used for cleanup.
	         * @param  {Function} onFinally A Function called when the Promise is settled.
	         * It will not receive any argument.
	         * @return {Yaku} A Promise that will reject if onFinally throws an error or returns a rejected promise.
	         * Else it will resolve previous promise's final state (either fulfilled or rejected).
	         * @example
	         * ```js
	         * var Promise = require('yaku');
	         * var p = Math.random() > 0.5 ? Promise.resolve() : Promise.reject();
	         * p.finally(() => {
	         *     console.log('finally');
	         * });
	         * ```
	         */
	        "finally": function (onFinally) {
	            return this.then(function (val) {
	                return Yaku.resolve(onFinally()).then(function () {
	                    return val;
	                });
	            }, function (err) {
	                return Yaku.resolve(onFinally()).then(function () {
	                    throw err;
	                });
	            });
	        },
	
	        // The number of current promises that attach to this Yaku instance.
	        _c: 0,
	
	        // The parent Yaku.
	        _p: $null
	    });
	
	    /**
	     * The `Promise.resolve(value)` method returns a Promise object that is resolved with the given value.
	     * If the value is a thenable (i.e. has a then method), the returned promise will "follow" that thenable,
	     * adopting its eventual state; otherwise the returned promise will be fulfilled with the value.
	     * @param  {Any} value Argument to be resolved by this Promise.
	     * Can also be a Promise or a thenable to resolve.
	     * @return {Yaku}
	     * @example
	     * ```js
	     * var Promise = require('yaku');
	     * var p = Promise.resolve(10);
	     * ```
	     */
	    Yaku.resolve = function (val) {
	        return isYaku(val) ? val : settleWithX(newCapablePromise(this), val);
	    };
	
	    /**
	     * The `Promise.reject(reason)` method returns a Promise object that is rejected with the given reason.
	     * @param  {Any} reason Reason why this Promise rejected.
	     * @return {Yaku}
	     * @example
	     * ```js
	     * var Promise = require('yaku');
	     * var p = Promise.reject(new Error("ERR"));
	     * ```
	     */
	    Yaku.reject = function (reason) {
	        return settlePromise(newCapablePromise(this), $rejected, reason);
	    };
	
	    /**
	     * The `Promise.race(iterable)` method returns a promise that resolves or rejects
	     * as soon as one of the promises in the iterable resolves or rejects,
	     * with the value or reason from that promise.
	     * @param  {iterable} iterable An iterable object, such as an Array.
	     * @return {Yaku} The race function returns a Promise that is settled
	     * the same way as the first passed promise to settle.
	     * It resolves or rejects, whichever happens first.
	     * @example
	     * ```js
	     * var Promise = require('yaku');
	     * Promise.race([
	     *     123,
	     *     Promise.resolve(0)
	     * ])
	     * .then((value) => {
	     *     console.log(value); // => 123
	     * });
	     * ```
	     */
	    Yaku.race = function (iterable) {
	        var self = this
	        , p = newCapablePromise(self)
	
	        , resolve = function (val) {
	            settlePromise(p, $resolved, val);
	        }
	
	        , reject = function (val) {
	            settlePromise(p, $rejected, val);
	        }
	
	        , ret = genTryCatcher(each)(iterable, function (v) {
	            self.resolve(v).then(resolve, reject);
	        });
	
	        if (ret === $tryErr) return self.reject(ret.e);
	
	        return p;
	    };
	
	    /**
	     * The `Promise.all(iterable)` method returns a promise that resolves when
	     * all of the promises in the iterable argument have resolved.
	     *
	     * The result is passed as an array of values from all the promises.
	     * If something passed in the iterable array is not a promise,
	     * it's converted to one by Promise.resolve. If any of the passed in promises rejects,
	     * the all Promise immediately rejects with the value of the promise that rejected,
	     * discarding all the other promises whether or not they have resolved.
	     * @param  {iterable} iterable An iterable object, such as an Array.
	     * @return {Yaku}
	     * @example
	     * ```js
	     * var Promise = require('yaku');
	     * Promise.all([
	     *     123,
	     *     Promise.resolve(0)
	     * ])
	     * .then((values) => {
	     *     console.log(values); // => [123, 0]
	     * });
	     * ```
	     * @example
	     * Use with iterable.
	     * ```js
	     * var Promise = require('yaku');
	     * Promise.all((function * () {
	     *     yield 10;
	     *     yield new Promise(function (r) { setTimeout(r, 1000, "OK") });
	     * })())
	     * .then((values) => {
	     *     console.log(values); // => [123, 0]
	     * });
	     * ```
	     */
	    Yaku.all = function (iterable) {
	        var self = this
	        , p1 = newCapablePromise(self)
	        , res = []
	        , ret
	        ;
	
	        function reject (reason) {
	            settlePromise(p1, $rejected, reason);
	        }
	
	        ret = genTryCatcher(each)(iterable, function (item, i) {
	            self.resolve(item).then(function (value) {
	                res[i] = value;
	                if (!--ret) settlePromise(p1, $resolved, res);
	            }, reject);
	        });
	
	        if (ret === $tryErr) return self.reject(ret.e);
	
	        if (!ret) settlePromise(p1, $resolved, []);
	
	        return p1;
	    };
	
	    /**
	     * The ES6 Symbol object that Yaku should use, by default it will use the
	     * global one.
	     * @type {Object}
	     * @example
	     * ```js
	     * var core = require("core-js/library");
	     * var Promise = require("yaku");
	     * Promise.Symbol = core.Symbol;
	     * ```
	     */
	    Yaku.Symbol = root[$Symbol] || {};
	
	    // To support browsers that don't support `Object.defineProperty`.
	    genTryCatcher(function () {
	        Object.defineProperty(Yaku, getSpecies(), {
	            get: function () { return this; }
	        });
	    })();
	
	    /**
	     * Use this api to custom the species behavior.
	     * https://tc39.github.io/ecma262/#sec-speciesconstructor
	     * @param {Any} O The current this object.
	     * @param {Function} defaultConstructor
	     */
	    Yaku.speciesConstructor = function (O, D) {
	        var C = O.constructor;
	
	        return C ? (C[getSpecies()] || D) : D;
	    };
	
	    /**
	     * Catch all possibly unhandled rejections. If you want to use specific
	     * format to display the error stack, overwrite it.
	     * If it is set, auto `console.error` unhandled rejection will be disabled.
	     * @param {Any} reason The rejection reason.
	     * @param {Yaku} p The promise that was rejected.
	     * @example
	     * ```js
	     * var Promise = require('yaku');
	     * Promise.unhandledRejection = (reason) => {
	     *     console.error(reason);
	     * };
	     *
	     * // The console will log an unhandled rejection error message.
	     * Promise.reject('my reason');
	     *
	     * // The below won't log the unhandled rejection error message.
	     * Promise.reject('v')["catch"](() => {});
	     * ```
	     */
	    Yaku.unhandledRejection = function (reason, p) {
	        console && console.error(
	            $unhandledRejectionMsg,
	            isLongStackTrace ? p.longStack : genStackInfo(reason, p)
	        );
	    };
	
	    /**
	     * Emitted whenever a Promise was rejected and an error handler was
	     * attached to it (for example with `["catch"]()`) later than after an event loop turn.
	     * @param {Any} reason The rejection reason.
	     * @param {Yaku} p The promise that was rejected.
	     */
	    Yaku.rejectionHandled = $noop;
	
	    /**
	     * It is used to enable the long stack trace.
	     * Once it is enabled, it can't be reverted.
	     * While it is very helpful in development and testing environments,
	     * it is not recommended to use it in production. It will slow down
	     * application and eat up memory.
	     * It will add an extra property `longStack` to the Error object.
	     * @example
	     * ```js
	     * var Promise = require('yaku');
	     * Promise.enableLongStackTrace();
	     * Promise.reject(new Error("err"))["catch"]((err) => {
	     *     console.log(err.longStack);
	     * });
	     * ```
	     */
	    Yaku.enableLongStackTrace = function () {
	        isLongStackTrace = true;
	    };
	
	    /**
	     * Only Node has `process.nextTick` function. For browser there are
	     * so many ways to polyfill it. Yaku won't do it for you, instead you
	     * can choose what you prefer. For example, this project
	     * [next-tick](https://github.com/medikoo/next-tick).
	     * By default, Yaku will use `process.nextTick` on Node, `setTimeout` on browser.
	     * @type {Function}
	     * @example
	     * ```js
	     * var Promise = require('yaku');
	     * Promise.nextTick = require('next-tick');
	     * ```
	     * @example
	     * You can even use sync resolution if you really know what you are doing.
	     * ```js
	     * var Promise = require('yaku');
	     * Promise.nextTick = fn => fn();
	     * ```
	     */
	    Yaku.nextTick = isBrowser ?
	        function (fn) {
	            nativePromise ?
	                new nativePromise(function (resolve) { resolve(); }).then(fn) :
	                setTimeout(fn);
	        } :
	        process.nextTick;
	
	    // ********************** Private **********************
	
	    Yaku._s = 1;
	
	    /**
	     * All static variable name will begin with `$`. Such as `$rejected`.
	     * @private
	     */
	
	    // ******************************* Utils ********************************
	
	    function getSpecies () {
	        return Yaku[$Symbol][$species] || $speciesKey;
	    }
	
	    function extend (src, target) {
	        for (var k in target) {
	            src[k] = target[k];
	        }
	    }
	
	    function isObject (obj) {
	        return obj && typeof obj === "object";
	    }
	
	    function isFunction (obj) {
	        return typeof obj === "function";
	    }
	
	    function isInstanceOf (a, b) {
	        return a instanceof b;
	    }
	
	    function isError (obj) {
	        return isInstanceOf(obj, Err);
	    }
	
	    function ensureType (obj, fn, msg) {
	        if (!fn(obj)) throw genTypeError(msg);
	    }
	
	    /**
	     * Wrap a function into a try-catch.
	     * @private
	     * @return {Any | $tryErr}
	     */
	    function tryCatcher () {
	        try {
	            return $tryCatchFn.apply($tryCatchThis, arguments);
	        } catch (e) {
	            $tryErr.e = e;
	            return $tryErr;
	        }
	    }
	
	    /**
	     * Generate a try-catch wrapped function.
	     * @private
	     * @param  {Function} fn
	     * @return {Function}
	     */
	    function genTryCatcher (fn, self) {
	        $tryCatchFn = fn;
	        $tryCatchThis = self;
	        return tryCatcher;
	    }
	
	    /**
	     * Generate a scheduler.
	     * @private
	     * @param  {Integer}  initQueueSize
	     * @param  {Function} fn `(Yaku, Value) ->` The schedule handler.
	     * @return {Function} `(Yaku, Value) ->` The scheduler.
	     */
	    function genScheduler (initQueueSize, fn) {
	        /**
	         * All async promise will be scheduled in
	         * here, so that they can be execute on the next tick.
	         * @private
	         */
	        var fnQueue = Arr(initQueueSize)
	        , fnQueueLen = 0;
	
	        /**
	         * Run all queued functions.
	         * @private
	         */
	        function flush () {
	            var i = 0;
	            while (i < fnQueueLen) {
	                fn(fnQueue[i], fnQueue[i + 1]);
	                fnQueue[i++] = $undefined;
	                fnQueue[i++] = $undefined;
	            }
	
	            fnQueueLen = 0;
	            if (fnQueue.length > initQueueSize) fnQueue.length = initQueueSize;
	        }
	
	        return function (v, arg) {
	            fnQueue[fnQueueLen++] = v;
	            fnQueue[fnQueueLen++] = arg;
	
	            if (fnQueueLen === 2) Yaku.nextTick(flush);
	        };
	    }
	
	    /**
	     * Generate a iterator
	     * @param  {Any} obj
	     * @private
	     * @return {Object || TypeError}
	     */
	    function each (iterable, fn) {
	        var len
	        , i = 0
	        , iter
	        , item
	        , ret
	        ;
	
	        if (!iterable) throw genTypeError($invalidArgument);
	
	        var gen = iterable[Yaku[$Symbol][$iterator]];
	        if (isFunction(gen))
	            iter = gen.call(iterable);
	        else if (isFunction(iterable.next)) {
	            iter = iterable;
	        }
	        else if (isInstanceOf(iterable, Arr)) {
	            len = iterable.length;
	            while (i < len) {
	                fn(iterable[i], i++);
	            }
	            return i;
	        } else
	            throw genTypeError($invalidArgument);
	
	        while (!(item = iter.next()).done) {
	            ret = genTryCatcher(fn)(item.value, i++);
	            if (ret === $tryErr) {
	                isFunction(iter[$return]) && iter[$return]();
	                throw ret.e;
	            }
	        }
	
	        return i;
	    }
	
	    /**
	     * Generate type error object.
	     * @private
	     * @param  {String} msg
	     * @return {TypeError}
	     */
	    function genTypeError (msg) {
	        return new TypeError(msg);
	    }
	
	    function genTraceInfo (noTitle) {
	        return (noTitle ? "" : $fromPrevious) + new Err().stack;
	    }
	
	
	    // *************************** Promise Helpers ****************************
	
	    /**
	     * Resolve the value returned by onFulfilled or onRejected.
	     * @private
	     * @param {Yaku} p1
	     * @param {Yaku} p2
	     */
	    var scheduleHandler = genScheduler(999, function (p1, p2) {
	        var x, handler;
	
	        // 2.2.2
	        // 2.2.3
	        handler = p1._s !== $rejected ? p2._onFulfilled : p2._onRejected;
	
	        // 2.2.7.3
	        // 2.2.7.4
	        if (handler === $undefined) {
	            settlePromise(p2, p1._s, p1._v);
	            return;
	        }
	
	        // 2.2.7.1
	        x = genTryCatcher(callHanler)(handler, p1._v);
	        if (x === $tryErr) {
	            // 2.2.7.2
	            settlePromise(p2, $rejected, x.e);
	            return;
	        }
	
	        settleWithX(p2, x);
	    });
	
	    var scheduleUnhandledRejection = genScheduler(9, function (p) {
	        if (!hashOnRejected(p)) {
	            p[$unhandled] = 1;
	            emitEvent($unhandledRejection, p);
	        }
	    });
	
	    function emitEvent (name, p) {
	        var browserEventName = "on" + name.toLowerCase()
	            , browserHandler = root[browserEventName];
	
	        if (process && process.listeners(name).length)
	            name === $unhandledRejection ?
	                process.emit(name, p._v, p) : process.emit(name, p);
	        else if (browserHandler)
	            browserHandler({ reason: p._v, promise: p });
	        else
	            Yaku[name](p._v, p);
	    }
	
	    function isYaku (val) { return val && val._s; }
	
	    function newCapablePromise (Constructor) {
	        if (isYaku(Constructor)) return new Constructor($noop);
	
	        var p, r, j;
	        p = new Constructor(function (resolve, reject) {
	            if (p) throw genTypeError();
	
	            r = resolve;
	            j = reject;
	        });
	
	        ensureType(r, isFunction);
	        ensureType(j, isFunction);
	
	        return p;
	    }
	
	    /**
	     * It will produce a settlePromise function to user.
	     * Such as the resolve and reject in this `new Yaku (resolve, reject) ->`.
	     * @private
	     * @param  {Yaku} self
	     * @param  {Integer} state The value is one of `$pending`, `$resolved` or `$rejected`.
	     * @return {Function} `(value) -> undefined` A resolve or reject function.
	     */
	    function genSettler (self, state) {
	        var isCalled = false;
	        return function (value) {
	            if (isCalled) return;
	            isCalled = true;
	
	            if (isLongStackTrace)
	                self[$settlerTrace] = genTraceInfo(true);
	
	            if (state === $resolved)
	                settleWithX(self, value);
	            else
	                settlePromise(self, state, value);
	        };
	    }
	
	    /**
	     * Link the promise1 to the promise2.
	     * @private
	     * @param {Yaku} p1
	     * @param {Yaku} p2
	     * @param {Function} onFulfilled
	     * @param {Function} onRejected
	     */
	    function addHandler (p1, p2, onFulfilled, onRejected) {
	        // 2.2.1
	        if (isFunction(onFulfilled))
	            p2._onFulfilled = onFulfilled;
	        if (isFunction(onRejected)) {
	            if (p1[$unhandled]) emitEvent($rejectionHandled, p1);
	
	            p2._onRejected = onRejected;
	        }
	
	        if (isLongStackTrace) p2._p = p1;
	        p1[p1._c++] = p2;
	
	        // 2.2.6
	        if (p1._s !== $pending)
	            scheduleHandler(p1, p2);
	
	        // 2.2.7
	        return p2;
	    }
	
	    // iterate tree
	    function hashOnRejected (node) {
	        // A node shouldn't be checked twice.
	        if (node._umark)
	            return true;
	        else
	            node._umark = true;
	
	        var i = 0
	        , len = node._c
	        , child;
	
	        while (i < len) {
	            child = node[i++];
	            if (child._onRejected || hashOnRejected(child)) return true;
	        }
	    }
	
	    function genStackInfo (reason, p) {
	        var stackInfo = [];
	
	        function push (trace) {
	            return stackInfo.push(trace.replace(/^\s+|\s+$/g, ""));
	        }
	
	        if (isLongStackTrace) {
	            if (p[$settlerTrace])
	                push(p[$settlerTrace]);
	
	            // Hope you guys could understand how the back trace works.
	            // We only have to iterate through the tree from the bottom to root.
	            (function iter (node) {
	                if (node && $promiseTrace in node) {
	                    iter(node._next);
	                    push(node[$promiseTrace] + "");
	                    iter(node._p);
	                }
	            })(p);
	        }
	
	        return (reason && reason.stack ? reason.stack : reason) +
	            ("\n" + stackInfo.join("\n")).replace($cleanStackReg, "");
	    }
	
	    function callHanler (handler, value) {
	        // 2.2.5
	        return handler(value);
	    }
	
	    /**
	     * Resolve or reject a promise.
	     * @private
	     * @param  {Yaku} p
	     * @param  {Integer} state
	     * @param  {Any} value
	     */
	    function settlePromise (p, state, value) {
	        var i = 0
	        , len = p._c;
	
	        // 2.1.2
	        // 2.1.3
	        if (p._s === $pending) {
	            // 2.1.1.1
	            p._s = state;
	            p._v = value;
	
	            if (state === $rejected) {
	                if (isLongStackTrace && isError(value)) {
	                    value.longStack = genStackInfo(value, p);
	                }
	
	                scheduleUnhandledRejection(p);
	            }
	
	            // 2.2.4
	            while (i < len) {
	                scheduleHandler(p, p[i++]);
	            }
	        }
	
	        return p;
	    }
	
	    /**
	     * Resolve or reject promise with value x. The x can also be a thenable.
	     * @private
	     * @param {Yaku} p
	     * @param {Any | Thenable} x A normal value or a thenable.
	     */
	    function settleWithX (p, x) {
	        // 2.3.1
	        if (x === p && x) {
	            settlePromise(p, $rejected, genTypeError($promiseCircularChain));
	            return p;
	        }
	
	        // 2.3.2
	        // 2.3.3
	        if (x !== $null && (isFunction(x) || isObject(x))) {
	            // 2.3.2.1
	            var xthen = genTryCatcher(getThen)(x);
	
	            if (xthen === $tryErr) {
	                // 2.3.3.2
	                settlePromise(p, $rejected, xthen.e);
	                return p;
	            }
	
	            if (isFunction(xthen)) {
	                if (isLongStackTrace && isYaku(x))
	                    p._next = x;
	
	                // Fix https://bugs.chromium.org/p/v8/issues/detail?id=4162
	                if (isYaku(x))
	                    settleXthen(p, x, xthen);
	                else
	                    Yaku.nextTick(function () {
	                        settleXthen(p, x, xthen);
	                    });
	            } else
	                // 2.3.3.4
	                settlePromise(p, $resolved, x);
	        } else
	            // 2.3.4
	            settlePromise(p, $resolved, x);
	
	        return p;
	    }
	
	    /**
	     * Try to get a promise's then method.
	     * @private
	     * @param  {Thenable} x
	     * @return {Function}
	     */
	    function getThen (x) { return x.then; }
	
	    /**
	     * Resolve then with its promise.
	     * @private
	     * @param  {Yaku} p
	     * @param  {Thenable} x
	     * @param  {Function} xthen
	     */
	    function settleXthen (p, x, xthen) {
	        // 2.3.3.3
	        var err = genTryCatcher(xthen, x)(function (y) {
	            // 2.3.3.3.3
	            // 2.3.3.3.1
	            x && (x = $null, settleWithX(p, y));
	        }, function (r) {
	            // 2.3.3.3.3
	            // 2.3.3.3.2
	            x && (x = $null, settlePromise(p, $rejected, r));
	        });
	
	        // 2.3.3.3.4.1
	        if (err === $tryErr && x) {
	            // 2.3.3.3.4.2
	            settlePromise(p, $rejected, err.e);
	            x = $null;
	        }
	    }
	
	    try {
	        module.exports = Yaku;
	    } catch (e) {
	        /* istanbul ignore next */
	        root.Yaku = Yaku;
	    }
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * An exception to skip execution of the experiment.
	 *
	 * This class has been extended without using ES6 so that "instanceof" works as intended.
	 *
	 * See:
	 * http://stackoverflow.com/questions/33870684/why-doesnt-instanceof-work-on-instances-of-error-subclasses-under-babel-node
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
	 */
	
	function WithdrawExperimentException(message) {
	  this.name = 'WithdrawExperimentException';
	  this.message = message || 'The experiment was withdrawn and will not run.';
	  this.stack = new Error().stack;
	}
	
	WithdrawExperimentException.prototype = Object.create(Error.prototype);
	WithdrawExperimentException.prototype.constructor = WithdrawExperimentException;
	
	exports.default = WithdrawExperimentException;
	module.exports = exports['default'];

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = false ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	"use strict";
	
	module.exports = {};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(6)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)os/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr\/|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , osname: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , osname: 'Chrome OS'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/edg([ea]|ios)/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , osname: 'Sailfish OS'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	        result.osname = 'Firefox OS'
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , osname: 'BlackBerry OS'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , osname: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , osname: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , osname: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && (android || result.silk)) {
	      result.android = t
	      result.osname = 'Android'
	    } else if (!result.windowsphone && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	      result.osname = 'iOS'
	    } else if (mac) {
	      result.mac = t
	      result.osname = 'macOS'
	    } else if (xbox) {
	      result.xbox = t
	      result.osname = 'Xbox'
	    } else if (windows) {
	      result.windows = t
	      result.osname = 'Windows'
	    } else if (linux) {
	      result.linux = t
	      result.osname = 'Linux'
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  return bowser
	});


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var CommonAnalyticsBroker = __webpack_require__(8);
	module.exports = new CommonAnalyticsBroker();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(fetch) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * CommonAnalyticsBroker
	 */
	var manifest = __webpack_require__(4);
	var assign = __webpack_require__(3);
	var GAS_SINGLE_EVENT_ENDPOINT = 'https://mgas.atlassian.io/v1/event';
	var Beacon = __webpack_require__(14);
	var ErrorEventProperties = __webpack_require__(15);
	var isDebuggingEnabled = __webpack_require__(16);
	
	function generateUUID() {
	  var octets = void 0;
	
	  if ((window.crypto || window.msCrypto || {}).getRandomValues) {
	    octets = (window.crypto || window.msCrypto).getRandomValues(new Uint8Array(16)).reduce(function (accum, value) {
	      accum.push(value >>> 4, value & 0x0F);
	      return accum;
	    }, []);
	  } else {
	    // Use Math.random();
	    octets = new Array(32);
	    for (var _i = 0; _i < octets.length; _i++) {
	      octets[_i] = Math.random() * 16 | 0;
	    }
	  }
	
	  var i = 0;
	  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
	    return (c === "x" ? octets[i++] : octets[i++] & 0x3 | 0x8).toString(16);
	  });
	}
	
	var CommonAnalyticsBroker = function () {
	  function CommonAnalyticsBroker() {
	    _classCallCheck(this, CommonAnalyticsBroker);
	
	    this._defaults = {
	      __cohortId: manifest.cohortId,
	      __product: manifest.product,
	      __guid: generateUUID() // GUID is used to provide a unique ID for collating events sent during the same page load
	    };
	    this._url = GAS_SINGLE_EVENT_ENDPOINT;
	    this.eventPrefix = manifest.eventPrefix;
	  }
	
	  _createClass(CommonAnalyticsBroker, [{
	    key: 'createRequest',
	    value: function createRequest(name) {
	      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return this._isGas() ? this.createGasRequest(name, properties) : this.createCloudRequest(name, properties);
	    }
	
	    /**
	     * Create a request which is suitable for the cloud-analytics plugin's "bulk" endpoint.
	     */
	
	  }, {
	    key: 'createCloudRequest',
	    value: function createCloudRequest(name) {
	      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return [{ name: name, properties: properties, timeDelta: 0 }];
	    }
	  }, {
	    key: 'createGasRequest',
	
	
	    /**
	     * Create a request which is suitable for GAS's single event endpoint.
	     */
	    value: function createGasRequest(name) {
	      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      return {
	        name: name,
	        server: this.group || window.location.hostname,
	        product: this.product || 'unknown',
	        user: this.user || '-',
	        serverTime: new Date().valueOf(),
	        properties: properties
	      };
	    }
	  }, {
	    key: 'setContext',
	    value: function setContext(_ref) {
	      var user = _ref.user,
	          product = _ref.product,
	          group = _ref.group,
	          cloudBaseUrl = _ref.cloudBaseUrl;
	
	      this.user = user;
	      this.product = product;
	      this.group = group;
	      if (typeof cloudBaseUrl === 'string') {
	        this._url = cloudBaseUrl + '/rest/analytics/1.0/publish/bulk';
	      } else {
	        this._url = GAS_SINGLE_EVENT_ENDPOINT;
	      }
	    }
	
	    /**
	     * Set default properties to be sent with any analytics event.
	     *
	     * Properties in the specified default will overwrite
	     * any current defaults.
	     */
	
	  }, {
	    key: 'assignDefaultProperties',
	    value: function assignDefaultProperties(defaults) {
	      assign(this._defaults, defaults);
	    }
	
	    /**
	     * Get the current defaults.
	     */
	
	  }, {
	    key: 'getDefaultProperties',
	    value: function getDefaultProperties() {
	      return assign({}, this._defaults);
	    }
	
	    /**
	     * Send the analytics event.
	     */
	
	  }, {
	    key: 'send',
	    value: function send() {
	      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
	      var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      // The hardcoded "grow0." ensures that the analytic event passes the whitelist on the server,
	      // regardless of what the experiment's actual experiment ID is.
	      var eventName = this.eventPrefix + '.' + name;
	      var mixedProperties = assign(this.getDefaultProperties(), properties);
	      if (isDebuggingEnabled()) {
	        console.log('%c' + JSON.stringify({ name: eventName, properties: mixedProperties }, null, 2), "color: blue; font-size: small");
	      }
	
	      if (false) {
	        return;
	      }
	
	      var successfullyQueued = false;
	      if (Beacon.isSupported()) {
	        var request = this.createRequest(eventName, mixedProperties);
	        successfullyQueued = this._isGas() ? Beacon.sendAsJsonText(this._url, request) : Beacon.sendAsJson(this._url, request);
	      }
	      if (!successfullyQueued) {
	        var _request = this.createRequest(eventName, assign(mixedProperties, { __ajax: true }));
	        fetch(this._url, {
	          method: 'POST',
	          headers: {
	            'Content-Type': 'application/json'
	          },
	          credentials: 'same-origin',
	          body: JSON.stringify(_request)
	        }).catch(function (e) {
	          setTimeout(function () {
	            e.message = 'There was an error sending an analytics event: ' + e.message;
	            throw e;
	          }, 0);
	        });
	      }
	    }
	
	    /**
	     * Send the specified error as an analytics event.
	     *
	     * Note: Only do this in production environments.
	     */
	
	  }, {
	    key: 'error',
	    value: function error(e) {
	      if (true) {
	        this.send('log.error', ErrorEventProperties.create(e));
	      }
	    }
	  }, {
	    key: '_isGas',
	    value: function _isGas() {
	      return this._url === GAS_SINGLE_EVENT_ENDPOINT;
	    }
	  }]);
	
	  return CommonAnalyticsBroker;
	}();
	
	exports.default = CommonAnalyticsBroker;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Request, Promise, whatwg_fetch) {'use strict';
	
	var DEFAULT_TIMEOUT = 30 * 1000;
	var ACCEPTABLE_TYPES = ['arrayBuffer', 'blob', 'json', 'text', 'formData'];
	
	var StatusChecker = __webpack_require__(13);
	
	var fetchExtra = function fetchExtra(input) {
	  var init = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var url = input instanceof Request ? input.url : input;
	  var timeout = init.timeout || DEFAULT_TIMEOUT;
	  var expectStatus = init.expectStatus;
	  var expectType = init.expectType;
	
	  var whenTimeout = new Promise(function (resolve, reject) {
	    return setTimeout(function () {
	      return reject(new Error('Timeout after ' + timeout + ' ms.'));
	    }, timeout);
	  });
	  var passthrough = function passthrough(x) {
	    return x;
	  };
	
	  var expectStatusHandler = function expectStatusHandler(response) {
	    if (StatusChecker.hasMatch(response.status, expectStatus)) {
	      return response;
	    } else {
	      throw new Error('Unexpected status ' + response.status + '.');
	    }
	  };
	
	  var expectTypeHandler = function expectTypeHandler(response) {
	    if (ACCEPTABLE_TYPES.indexOf(expectType) === -1) {
	      throw new Error('"' + expectType + '" is an invalid expected type.');
	    } else {
	      return response[expectType]();
	    }
	  };
	
	  return Promise.race([whatwg_fetch(input, init), whenTimeout]).then(expectStatus ? expectStatusHandler : passthrough).then(expectStatus && expectType ? expectTypeHandler : passthrough).catch(function (e) {
	    var error = new Error('Error fetching "' + url + '". Reason: ' + e.message);
	    error.stack = e.stack;
	    throw error;
	  });
	};
	module.exports = fetchExtra;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(10), __webpack_require__(1), __webpack_require__(12)))

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var lib = __webpack_require__(11);
	
	null
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = lib.Request;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {/*** IMPORTS FROM imports-loader ***/
	var self = {FormData:window.FormData};
	
	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (typeof input === 'string') {
	      this.url = input
	    } else {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split('\r\n').forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);
	
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = self;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var lib = __webpack_require__(11);
	
	null
	
	/*** EXPORTS FROM exports-loader ***/
	module.exports = lib.fetch;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * A helper class to help determine if a given HTTP status matches
	 * at least one status or pattern from a list.
	 */
	var StatusChecker = function () {
	  function StatusChecker() {
	    _classCallCheck(this, StatusChecker);
	  }
	
	  _createClass(StatusChecker, null, [{
	    key: 'hasMatch',
	
	
	    /**
	     * Determine if the specified HTTP status code matches
	     * at least one status or pattern from an array of statues/patterns.
	     *
	     * A status can either be a string (e.g. '200') or a number (e.g. 200).
	     *
	     * A pattern should use 'X' or 'x' to signify a wildcard. e.g. ('2xx' will match a 200, 201, 204 etc).
	     *
	     * @param status
	     * @param arrayOrObject - An array of statuses/patterns, or a single status/pattern.
	     */
	    value: function hasMatch(status, arrayOrObject) {
	      if (!StatusChecker.isValidStatus(status)) {
	        throw new Error('"' + status + '" is not a valid status.');
	      }
	      var list = Array.isArray(arrayOrObject) ? arrayOrObject : [arrayOrObject];
	      list.forEach(function (pattern) {
	        if (!StatusChecker.isValidPatternOrStatus(pattern)) {
	          throw new Error('"' + pattern + '" is not a valid status or pattern.');
	        }
	      });
	      return list.some(function (pattern) {
	        return !!String(status).match(String(pattern).replace(/(x|X)/g, '.'));
	      });
	    }
	
	    /**
	     * Returns true if the specified status is a valid status or pattern.
	     * @param status
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'isValidPatternOrStatus',
	    value: function isValidPatternOrStatus(status) {
	      return !!/^[0-9xX]{3}$/.exec(String(status));
	    }
	
	    /**
	     * Returns true if the specified status is a valid status.
	     * @param status
	     */
	
	  }, {
	    key: 'isValidStatus',
	    value: function isValidStatus(status) {
	      return !!/^[0-9]{3}$/.exec(String(status));
	    }
	  }]);
	
	  return StatusChecker;
	}();
	
	module.exports = StatusChecker;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Light wrapper around navigator.sendBeacon()
	 */
	var _isSupported = null;
	
	var Beacon = function () {
	  function Beacon() {
	    _classCallCheck(this, Beacon);
	  }
	
	  _createClass(Beacon, null, [{
	    key: 'sendAsJson',
	
	
	    /**
	     * Send the specified object as JSON using Beacon API.
	     *
	     * See:
	     * - https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API
	     * - https://w3c.github.io/beacon/#dom-navigator-sendbeacon
	     *
	     * Returns a boolean to indicate that the data was successfully queued.
	     *
	     * If we've exceeded our quota for sendBeacon on this page, this method
	     * will return false.
	     *
	     * See: https://www.w3.org/TR/beacon/#sec-sendBeacon-method
	     *
	     * @param url
	     * @param object
	     * @returns {boolean}
	     */
	    value: function sendAsJson(url, object) {
	      try {
	        var blob = new Blob([JSON.stringify(object)], { type: 'application/json' });
	        return navigator.sendBeacon(url, blob);
	      } catch (err) {
	        return false; // If Chrome complains about CORS preflights for beacon
	      }
	    }
	
	    /**
	     * Send the specified object as JSON using Beacon API.
	     *
	     * See:
	     * - https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API
	     * - https://w3c.github.io/beacon/#dom-navigator-sendbeacon
	     *
	     * Returns a boolean to indicate that the data was successfully queued.
	     *
	     * If we've exceeded our quota for sendBeacon on this page, this method
	     * will return false.
	     *
	     * See: https://www.w3.org/TR/beacon/#sec-sendBeacon-method
	     *
	     * @param url
	     * @param object
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'sendAsJsonText',
	    value: function sendAsJsonText(url, object) {
	      /**
	       * HACK: We're sending text/plain for 2 reasons:
	       * - we avoid a pre-flight request
	       * - workaround to an issue introduced in Chrome 59 ( http://crbug.com/490015 )
	       */
	      try {
	        var blob = new Blob([JSON.stringify(object)], { type: 'text/plain' });
	        return navigator.sendBeacon(url, blob);
	      } catch (err) {
	        return false; // If Chrome complains about CORS preflights for beacon
	      }
	    }
	
	    /**
	     * Returns a boolean to indicate whether Beacon is supported.
	     */
	
	  }, {
	    key: 'isSupported',
	    value: function isSupported() {
	      if (typeof _isSupported !== 'boolean') {
	        _isSupported = this.isSendBeaconSupported() && this.isBlobSupported();
	      }
	      return _isSupported;
	    }
	
	    /**
	     * Returns a boolean to indicate whether navigator.sendBeacon is available.
	     */
	
	  }, {
	    key: 'isSendBeaconSupported',
	    value: function isSendBeaconSupported() {
	      // Modified from: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/network/beacon.js
	      return 'sendBeacon' in navigator && typeof navigator.sendBeacon === 'function';
	    }
	
	    /**
	     * Returns a boolean to indicate whether Blob is available.
	     */
	
	  }, {
	    key: 'isBlobSupported',
	    value: function isBlobSupported() {
	      // Source: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/blob.js
	      try {
	        return !!new Blob();
	      } catch (e) {
	        return false;
	      }
	    }
	  }]);
	
	  return Beacon;
	}();
	
	exports.default = Beacon;
	module.exports = exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var toString = Object.prototype.toString;
	var isArray = function isArray(value) {
	  return toString.call(value) === '[object Array]';
	};
	var isObject = function isObject(value) {
	  return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !isArray(value);
	};
	var isNonEmptyString = function isNonEmptyString(value) {
	  return typeof value === 'string' && value.trim().length > 0;
	};
	
	var ErrorEventProperties = function () {
	  function ErrorEventProperties() {
	    _classCallCheck(this, ErrorEventProperties);
	  }
	
	  _createClass(ErrorEventProperties, null, [{
	    key: 'create',
	
	    /**
	     * Attempt to create event properties for the specified object
	     * and the current context.
	     *
	     * Note: Ideally, this object should be an Error object, but
	     * it could be anything (eg. null, undefined, etc).
	     */
	    value: function create(object) {
	      var properties = {};
	
	      // Contextual information.
	      if (isNonEmptyString(location.pathname)) {
	        properties.path = location.pathname;
	      }
	      if (isNonEmptyString(location.hash)) {
	        properties.hash = location.hash;
	      }
	      if (isNonEmptyString(location.hostname)) {
	        properties.hostname = location.hostname;
	      }
	      if (isNonEmptyString(location.search)) {
	        properties.querystring = location.search;
	      }
	      if (isNonEmptyString(navigator.userAgent)) {
	        properties.userAgent = navigator.userAgent;
	      }
	
	      // Object information.
	      if (isObject(object)) {
	        if (isNonEmptyString(object.message)) {
	          properties.message = object.message;
	        }
	        if (isNonEmptyString(object.stack)) {
	          properties.stack = object.stack;
	        }
	      } else {
	        try {
	          properties.message = String(object);
	        } catch (e) {
	          try {
	            properties.message = toString.call(object);
	          } catch (e) {
	            // silence
	          }
	        }
	      }
	      return properties;
	    }
	  }]);
	
	  return ErrorEventProperties;
	}();
	
	module.exports = ErrorEventProperties;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Should debugging information be displayed
	 */
	module.exports = function () {
	  if (false) {
	    return true;
	  } else {
	    try {
	      return localStorage.getItem('growDebug') !== null;
	    } catch (e) {
	      return false;
	    }
	  }
	};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Bubble the specified error to the top/window, in it's
	 * own execution stack.
	 *
	 * This appears to the best way to report an error to the console.
	 *
	 * Note: Don't use "console.error", it's not standard.
	 * The top-most stack frame references the invocation of "console.error"
	 * which is useless when debugging.
	 */
	module.exports = function (e) {
	  setTimeout(function () {
	    throw e;
	  }, 0);
	};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var CloudContext = __webpack_require__(19);
	
	module.exports = CloudContext();

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getMetaAttributeValue = __webpack_require__(20);
	
	var startsWith = function startsWith(string, search) {
	  return string.indexOf(search) === 0;
	};
	/**
	 * Return information about the current context.
	 *
	 * Everything here needs to be calculated without the presence of <body>.
	 *
	 * This function should make a best effort to gracefully fail.
	 */
	var CloudContext = function CloudContext() {
	  var hostname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
	  var pathname = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.pathname;
	
	  var PRODUCT_JIRA = 'jira';
	  var PRODUCT_CONFLUENCE = 'confluence';
	  var PRODUCT_CROWD = 'crowd';
	  var PRODUCT_BITBUCKET = 'bitbucket';
	
	  var product = 'unknown';
	  var user = void 0;
	  var cloudBaseUrl = void 0;
	  try {
	    if (getMetaAttributeValue('application-name', 'data-name') === 'jira') {
	      product = PRODUCT_JIRA;
	      user = getMetaAttributeValue('ajs-remote-user', 'content');
	      cloudBaseUrl = '';
	    } else if (getMetaAttributeValue('confluence-base-url', 'content') || startsWith(pathname, '/wiki')) {
	      product = PRODUCT_CONFLUENCE;
	      user = getMetaAttributeValue('ajs-remote-user', 'content');
	      cloudBaseUrl = getMetaAttributeValue('confluence-base-url', 'content') || '/wiki';
	    } else if (startsWith(pathname, '/admin')) {
	      product = PRODUCT_CROWD;
	      user = getMetaAttributeValue('remote-username', 'content');
	    } else if (getMetaAttributeValue('bb-bootstrap', 'data-current-user')) {
	      var bbBootstrap = JSON.parse(getMetaAttributeValue('bb-bootstrap', 'data-current-user'));
	      product = PRODUCT_BITBUCKET;
	      hostname = 'production';
	      user = bbBootstrap.id;
	    }
	  } catch (e) {
	    // silence
	  }
	  return { user: user, product: product, group: hostname, cloudBaseUrl: cloudBaseUrl };
	};
	
	module.exports = CloudContext;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMetaAttributeValue;
	/**
	 * Get the attribute value for the first element that matches
	 * the specified name.
	 */
	function getMetaAttributeValue(name, attributeName) {
	  var elements = [].slice.call(window.document.head.getElementsByTagName('meta')).filter(function (element) {
	    return element.getAttribute('name') === name || element.getAttribute('id') === name;
	  });
	  return elements[0] ? elements[0].getAttribute(attributeName) : null;
	}
	module.exports = exports['default'];

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var shouldRun = __webpack_require__(22);
	var WithdrawExperimentException = __webpack_require__(2);
	
	/**
	 * This is your opportunity to do stuff synchronously as the HEAD loads.
	 * <opportunity>
	 */
	
	/**
	 * Warning: attempting to use jQuery before the "jquery-requirement" check in shouldRun won't work.
	 */
	
	shouldRun().then(function () {
	  __webpack_require__(26).init();
	}).catch(function (e) {
	  if (!(e instanceof WithdrawExperimentException)) {
	    throw e;
	  }
	});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {"use strict";
	
	var _withdrawExperimentException = __webpack_require__(2);
	
	var _withdrawExperimentException2 = _interopRequireDefault(_withdrawExperimentException);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Change this to true if you need JQuery
	var JQUERY_REQUIRED = true; /**
	                             * This is the place to encapsulate any common requirements for
	                             * all cohorts (ie. control & variations).
	                             *
	                             * Returns a Promise. If it meets the requirements of this experiment,
	                             * resolve it, otherwise reject with the WithdrawExperimentException.
	                             * meets the requirements for this experiment.
	                             */
	
	module.exports = function () {
	    return (JQUERY_REQUIRED ? __webpack_require__(23).check() : Promise.resolve()).then(function () {
	        // TODO: Introduce conditions appropriate to your experiment.
	        if (/.*/.test(window.location.pathname)) {
	            return true;
	        } else {
	            throw new _withdrawExperimentException2.default();
	        }
	    });
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var whenJQuery = __webpack_require__(24);
	var WithdrawExperimentException = __webpack_require__(2);
	
	var JQueryRequirement = function () {
	  function JQueryRequirement() {
	    _classCallCheck(this, JQueryRequirement);
	  }
	
	  _createClass(JQueryRequirement, null, [{
	    key: 'check',
	    value: function check() {
	      return whenJQuery().then(function ($) {
	        var moduleId = /*require.resolve*/(25);
	        // Manually insert it into the cache.
	        __webpack_require__.c[moduleId] = {
	          exports: $,
	          id: moduleId,
	          loaded: true
	        };
	        return $;
	      }).catch(function (e) {
	        if (e instanceof Error && typeof e.message === 'string' && e.message.indexOf('Could not find jQuery in') === 0) {
	          throw new WithdrawExperimentException(e.message);
	        } else {
	          throw e;
	        }
	      });
	    }
	  }]);
	
	  return JQueryRequirement;
	}();
	
	module.exports = JQueryRequirement;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var TIME_LIMIT_MS = 20 * 1000;
	  var OFTEN_MS = 10;
	  var expiry = new Date().valueOf() + TIME_LIMIT_MS;
	  var intervalId = null;
	  return new Promise(function (resolve, reject) {
	    intervalId = setInterval(function () {
	      var now = new Date().valueOf();
	      if (now > expiry) {
	        reject(new Error('Could not find jQuery in ' + TIME_LIMIT_MS + ' ms'));
	      } else {
	        var jQuery = findjQuery();
	        if (jQuery) {
	          clearInterval(intervalId);
	          intervalId = null;
	          resolve(jQuery);
	        }
	      }
	    }, OFTEN_MS);
	  });
	};
	
	/**
	 * This module provides a reliable mechanism to get hold of the jQuery facade global.
	 *
	 * This is NOT as simple as looking for objects in the global scope.
	 *
	 * e.g. In Confluence, it's possible for the browser to fail to load jQuery from
	 * Google's CDN but then our (Atlassian) JS will initialize $.
	 * For more details, see: https://jdog.jira-dev.com/browse/PGI-695
	 *
	 * This modules assumes that jQuery is expected to be present before the
	 * experiment's JS is loaded. If it finds jQuery, it will return it, otherwise it will return null.
	 *
	 * This should work across all products. (JIRA, Confluence, HipChat, WAC).
	 */
	var Promise = __webpack_require__(1);
	
	/**
	 * Verify that the specified object is the jQuery facade.
	 *
	 * If it is, return the object, otherwise return null.
	 */
	function verify(object) {
	  var jQuery = void 0;
	  try {
	    jQuery = typeof object.fn.jquery === 'string' ? object : null;
	  } catch (e) {
	    jQuery = null;
	  }
	  return jQuery;
	}
	
	/**
	 * Look for the jQuery facade object.
	 *
	 * If we find it, return it. Otherwise returns null;
	 *
	 * We won't use Optimizely's incomplete version of jQuery
	 * by using window.$ instead of $
	 *
	 * @returns {jQuery}
	 */
	function findjQuery() {
	  var jQuery = null;
	  try {
	    jQuery = jQuery || verify(window.require('jquery'));
	  } catch (e) {}
	  try {
	    jQuery = jQuery || verify(AJS.$);
	  } catch (e) {}
	  try {
	    jQuery = jQuery || verify(window.$);
	  } catch (e) {}
	  try {
	    jQuery = jQuery || verify(window.jQuery);
	  } catch (e) {}
	  return jQuery;
	}
	
	/**
	 * Returns a promise which is resolved with jQuery,
	 * if it can be found in time.
	 *
	 * Otherwise the promise is rejected.
	 * @returns {Promise}
	 */
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 25 */
4,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * This is a module which represents a sample treatment.
	 *
	 * It's a great starting point, which will help you:
	 * - signal "experiment.triggered" events in a consistent way for the "control" cohort
	 * - express targeting/triggers in a single module
	 * - express treatment in a single module
	 * - express requirements in a single module
	 *
	 * If it makes sense to refactor/rename the methods, then please do so!
	 */
	
	var _require = __webpack_require__(27),
	    doForCohortsNamed = _require.doForCohortsNamed,
	    CONTROL = _require.CONTROL;
	
	var _require2 = __webpack_require__(28),
	    Waiter = _require2.Waiter,
	    WaiterTimeoutException = _require2.WaiterTimeoutException,
	    WaiterCancelException = _require2.WaiterCancelException;
	
	// Use this to record any state which may be passed in through init(), and used
	// while preparing or applying the treatment.
	
	
	var state = {};
	
	/**
	 * A great place to setup a trigger, or do preparation
	 * that is helpful to occur much earlier than when applying treatment.
	 *
	 * This should be used for changes that must be applied immediately and synchronously,
	 * such as appending stylesheets.
	 *
	 * This could also be used to setup any analytics on existing features that should be
	 * applied in both control and variations.
	 *
	 * If you need to do something for a specific variation, use doForCohortsNamed.
	 */
	function prepareTreatment() {
	    doForCohortsNamed(CONTROL, function () {});
	}
	
	/**
	 * Fire an "experiment.triggered.*" event.
	 *
	 * Signifies that the user has met the appropriate requirements,
	 * that would have, or will apply treatment.
	 *
	 * You should invoke this any time a user has a different experience than
	 * in the "control" variation.
	 *
	 * Name this appropriately for your treatment!
	 */
	function wouldSeeTreatment() {
	    __webpack_require__(29)();
	}
	
	/**
	 * Apply some kind of treatment.
	 *
	 * This might be a good place to call wouldSeeTreatment().
	 *
	 * If you need to do something for a specific variation, use doForCohortsNamed.
	 */
	function applyTreatment() {
	    wouldSeeTreatment();
	
	    doForCohortsNamed(CONTROL, function () {
	        var isInAdg2 = document.querySelector('body.adg3') === null;
	        if (!isInAdg2) {
	            return;
	        }
	
	        var contextPath = AJS.Meta.get('context-path');
	        var username = AJS.Meta.get('remote-user');
	        AJS.$.ajax({
	            type: 'GET',
	            url: contextPath + '/rest/api/2/user/properties/reset-adg3-dismissed-state?username=' + username,
	            dataType: 'json',
	            contentType: 'application/json'
	        }).done(function () {
	            __webpack_require__(31)();
	        }).fail(function (response) {
	            __webpack_require__(32)();
	            var notExistString = 'The property reset-adg3-dismissed-state does not exist.';
	            if (response.responseText.indexOf(notExistString) !== -1) {
	                resetAdg3DismissedState();
	            }
	        });
	
	        function resetAdg3DismissedState() {
	            __webpack_require__(33)();
	            AJS.$.ajax({
	                type: 'POST',
	                url: contextPath + '/rest/api/2/userProperties',
	                dataType: 'json',
	                contentType: 'application/json',
	                data: JSON.stringify({
	                    key: 'atl.jira.simplifyux.rejected',
	                    value: 'false'
	                })
	            }).done(function () {
	                __webpack_require__(34)();
	                setExperimentDone();
	            }).fail(function () {
	                __webpack_require__(35)();
	            });
	        }
	
	        function setExperimentDone() {
	            AJS.$.ajax({
	                type: 'PUT',
	                processData: false,
	                url: contextPath + '/rest/api/2/user/properties/reset-adg3-dismissed-state?username=' + username,
	                dataType: 'json',
	                contentType: 'application/json',
	                data: 'true'
	            }).done(function () {
	                __webpack_require__(36)();
	            });
	        }
	    });
	}
	
	module.exports = {
	    /**
	     * Initialize the (potential) treatment.
	     *
	     * This is an opportunity to setup triggers.
	     *
	     * Do not include/write code that applies treatment in this function.
	     * Instead, do this in another function (e.g. prepareTreatment, applyTreatment)
	     * and invoke this function instead.
	     */
	    init: function init(args1, args2) {
	        // Store any necessary state data
	        state['prop1'] = args1;
	        state['prop2'] = args2;
	
	        prepareTreatment();
	
	        // Determine when to apply the treatment. This can be done by, e.g.
	        // * Waiting for a specific element to appear
	        // * Waiting for a particular event to be fired, or similar.
	
	        // Wait for a specific element to be available before applying the treatment.
	        // Change selector as needed.
	        new Waiter("body").wait().then(applyTreatment).catch(function (e) {
	            if (e instanceof WaiterTimeoutException) {
	                // Timed out.
	            } else if (e instanceof WaiterCancelException) {
	                // Cancelled
	            } else {
	                // Something unexpected happened.
	                throw e;
	            }
	        });
	    }
	};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Various treatment utilities.
	 */
	var manifest = __webpack_require__(4);
	
	var currentCohortName = manifest.cohortName;
	
	/**
	 * Synchronously invoke the specified callback, if the
	 * current cohort name is amongst the specified cohort name(s).
	 *
	 * The cohort names argument, can either be a single string, or an array of string.
	 */
	module.exports.doForCohortsNamed = function (nameOrNames, callback) {
	  var cohortNames = typeof nameOrNames === 'string' && nameOrNames.length > 0 ? [nameOrNames] : Array.isArray(nameOrNames) ? nameOrNames : null;
	  if (!cohortNames || cohortNames.length === 0) {
	    throw new Error("Invalid argument. Please specify a string or an array.");
	  }
	  if (cohortNames.indexOf(currentCohortName) !== -1) {
	    callback();
	  }
	};
	
	module.exports.CONTROL = 'control';
	module.exports.VARIATION1 = 'variation-1';
	module.exports.VARIATION2 = 'variation-2';
	module.exports.VARIATION3 = 'variation-3';
	module.exports.VARIATION4 = 'variation-4';
	module.exports.VARIATION5 = 'variation-5';
	module.exports.VARIATION6 = 'variation-6';

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * An exception which communicates that this Waiter timed out.
	 * @param message
	 * @constructor
	 */
	function WaiterTimeoutException(message) {
	  this.name = 'WaiterTimeoutException';
	  this.message = message;
	  this.stack = new Error().stack;
	}
	WaiterTimeoutException.prototype = Object.create(Error.prototype);
	WaiterTimeoutException.prototype.constructor = WaiterTimeoutException;
	
	/**
	 * An exception which communicates that this Waiter was cancelled.
	 * @param message
	 * @constructor
	 */
	function WaiterCancelException(message) {
	  this.name = 'WaiterCancelException';
	  this.message = message;
	  this.stack = new Error().stack;
	}
	WaiterCancelException.prototype = Object.create(Error.prototype);
	WaiterCancelException.prototype.constructor = WaiterCancelException;
	
	var DEFAULT_TIMEOUT = 30 * 1000;
	var DEFAULT_PERIODIC = 50;
	
	var Waiter = function () {
	  /**
	   * Construct a Waiter.
	   * If a timeout value of 0 is specified, then no timeout will be applied. The default timeout is 30,000 milliseconds.
	   *
	   * @param selector
	   * @param timeout - a timeout in milliseconds
	   * @param document - supply an alternate (e.g. iframe) document element
	   * @param periodic - specify an amount of time to periodically check for the element
	   */
	  function Waiter(selector) {
	    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_TIMEOUT;
	    var document = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.document;
	    var periodic = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_PERIODIC;
	
	    _classCallCheck(this, Waiter);
	
	    this.selector = selector;
	    this.timeout = timeout;
	    this.document = document;
	    this.periodic = periodic;
	
	    this.intervalId = null;
	    this.promise = null;
	    this.reject = null;
	  }
	
	  _createClass(Waiter, [{
	    key: '_resetInterval',
	    value: function _resetInterval() {
	      if (typeof this.intervalId === 'number') {
	        clearInterval(this.intervalId);
	        this.intervalId = null;
	      }
	    }
	  }, {
	    key: 'cancel',
	    value: function cancel() {
	      this._resetInterval();
	      if (typeof this.reject === 'function') {
	        this.promise = null;
	        this.reject(new WaiterCancelException('Cancelled waiting for elements matching "' + this.selector + '".'));
	      }
	    }
	  }, {
	    key: 'wait',
	    value: function wait() {
	      var _this = this;
	
	      if (!this.promise) {
	        var expires = Date.now() + this.timeout;
	        this.promise = new Promise(function (resolve, reject) {
	          _this._resetInterval();
	          _this.intervalId = setInterval(function () {
	            var elements = _this.document.querySelectorAll(_this.selector);
	            if (elements.length > 0) {
	              _this._resetInterval();
	              _this.promise = null;
	              resolve(elements);
	            } else if (_this.timeout !== 0 && Date.now() > expires) {
	              _this._resetInterval();
	              _this.promise = null;
	              reject(new WaiterTimeoutException('Unexpectedly did not find any elements matching "' + _this.selector + '" after waiting ' + _this.timeout + ' ms.'));
	            }
	          }, _this.periodic);
	        });
	      }
	      return this.promise;
	    }
	  }]);
	
	  return Waiter;
	}();
	
	module.exports = { Waiter: Waiter, WaiterTimeoutException: WaiterTimeoutException, WaiterCancelException: WaiterCancelException };
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(30)('experiment.triggered.reset.adg3.dismissed.property');

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var analytics = __webpack_require__(7);
	
	module.exports = function (name) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    analytics.send.apply(analytics, [name].concat(args));
	  };
	};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(30)('experiment.was.already.done');

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(30)('experiment.getting.is.reset.adg3.dismissed.state.failed');

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(30)('experiment.reset.adg3.dismissed.state.will.do');

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(30)('experiment.reset.adg3.dismissed.state.done');

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(30)('experiment.reset.adg3.dismissed.state.failed');

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(30)('experiment.set.experiment.done');

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// control/jira.js